/**
 * Created by Alex Aguilar on 4/1/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('makerCtrl', makerCtrl)
        .controller('newMakerCtrl', newMakerCtrl)
        .controller('editMakerCtrl', editMakerCtrl)
        .controller('deleteMakerCtrl', deleteMakerCtrl)
        .controller('modalMakerCtrl', modalMakerCtrl);

    makerCtrl.$inject = ['linkService', 'makers','tabs'];
    newMakerCtrl.$inject = ['makerService','tabs','linkService'];
    editMakerCtrl.$inject = ['$stateParams', 'makerService', 'tabs','maker'];
    deleteMakerCtrl.$inject = ['$stateParams', 'makerId', 'maker', 'makerService', '$uibModalInstance'];
    modalMakerCtrl.$inject = ['$rootScope', '$scope', '$state', '$translate', 'toastr', '$stateParams','makerService', '$uibModalInstance'];

    function makerCtrl(linkService, makers,tabs){
        var vm = this;
        vm.linkService = linkService;
        vm.tabs = tabs;
        vm.makers = (makers.data._embedded) ? makers.data._embedded.makers : [];
        vm.pages = makers.data.page;

        vm.editMaker = function(makerId){
            vm.linkService.reloadRoute('makerEdit', {id : makerId});
        }
    };

    function newMakerCtrl(makerService,tabs,linkService){
        var vm = this;
        vm.tabs = tabs;

        vm.saveMaker = function(isValid, maker){
            if (isValid) {
                makerService.saveMaker(maker)
                    .then(function(){
                        linkService.reloadRoute('makerList');
                    });
            }
        }
    }

    function editMakerCtrl($stateParams, makerService,tabs,maker){
        var vm = this;
        vm.tabs = tabs;
        vm.maker = maker.data;
        vm.old = angular.copy(vm.maker);
        vm.buttonSave = true;

        vm.saveMaker = function(isValid, maker){
            if (isValid) {
                makerService.updateMaker(maker, $stateParams.id);
            }
        }

        vm.change = function(){
            if(vm.maker.name.toUpperCase() == vm.old.name.toUpperCase()){
                    vm.buttonSave = true;
            }else{
                vm.buttonSave = false;
            }
        }
    }

    function deleteMakerCtrl($stateParams, makerId, maker, makerService, $uibModalInstance){
        var vm = this;
        vm.maker = maker.data;

        vm.deleteMaker = function(){
            makerService.deleteMaker(makerId)
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function modalMakerCtrl($rootScope, $scope, $state, $translate, toastr, $stateParams, makerService, $uibModalInstance){
        var vm = this;
        $scope.saveMaker = function(isValid, maker){
            if (isValid) {
                makerService.saveMaker(maker)
                    .then(function(){
                        $uibModalInstance.close();
                    });
            }
        }

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();


